/* eslint-disable no-unused-vars */
import { useSelector } from 'react-redux';
import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core';
import InfoRow from '../widgets/InfoRow';
import BaseInfoWidget from '../widgets/BaseInfoWidget';
import Loader from '../../Shared/Loader';
import { currencyFormat } from '../../Shared/Table/helpers';

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    padding: '0 24px',
  },
  form: {},
}));

const Program = () => {
  const {
    currentPage: {
      currentPageContext: {
        value,
      },
    },
  } = useSelector((state) => state.infoPane);
  const { en: { infoPane } } = useSelector((state) => state.i18n);

  const classes = useStyles();

  return <BaseInfoWidget
    breadcrumbs={infoPane.info}
    title={infoPane.programInfo}
    subtitle={'Subtitle'}
    content={<div className={classes.container}>
      {'test data: ' + value}
    </div>
    }
  />;
};

export default Program;
